/**ResponseMessage sa BE */
export enum ErrorsEnum {
    KORISNIK_NEMA_PRAVA_NAD_ORGANOM = "KORISNIK_NEMA_PRAVA_NAD_ORGANOM",
    POSTOJI_OJ_SA_OVOM_SIFROM = "POSTOJI_OJ_SA_OVOM_SIFROM",
    KORISNIK_NEMA_PRAVA_NAD_OJ = "KORISNIK_NEMA_PRAVA_NAD_OJ",
    NE_POSTOJI_SIFRA_ORGANA = "NE_POSTOJI_SIFRA_ORGANA",
    NE_POSTOJI_SISTEMSKA_SIFRA = "NE_POSTOJI_SISTEMSKA_SIFRA",
    ERR_MAPIRANJE_OPERACIJA_I_ENDPOINTA = "ERR_MAPIRANJE_OPERACIJA_I_ENDPOINTA"
}